import * as yup from "yup";

export const PayrollScheduleValidationSchema = yup.object({
  year: yup.number().required("Year is required"),
  payPeriod: yup.string().required("Pay Period is required"),
  payPeriodLabel: yup.string().required("Pay Period Label is required"),
  firstPayPeriodEndDate: yup
    .date()
    .required("First Pay Period End Date is required"),
});
